import Css from "./style.module.scss";

import { TagsInput } from "nlib/ui";
import { getSelectedBusinessCategories, getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import React, { useMemo } from "react";
import classNames from "classnames";

const SelectUncategorizedCategoryNames = ({
  className,
  value = [],
  categories: propsCategories,
  uncategorizedCategoryNames: propsUncategorizedCategoryNames,
  ...props
}) => {
  const { uiTexts } = useSelector(getTextsData);

  const storedCategories = useSelector(getSelectedBusinessCategories);

  const {
    settings: { uncategorizedCategoryNames: storedUncategorizedCategoryNames = [] } = {}
  } = useSelector(getSelectedBusinessData);

  const uncategorizedCategoryNames = propsUncategorizedCategoryNames || storedUncategorizedCategoryNames;

  const categories = propsCategories || storedCategories;

  const autoCompleteData = useMemo(() => {
    return [...new Set([
      ...categories.map(({ name }) => name),
      ...uncategorizedCategoryNames,
      ...value
    ])]
      .filter(Boolean)
      .map((name) => ({ value: name, label: name }));
  }, [categories, uncategorizedCategoryNames, value]);

  return (
    <TagsInput
      onlyAutocompleteData
      autoCompleteData={autoCompleteData}
      className={classNames(Css.selectUncategorizedCategoryNames, className)}
      placeholder={uiTexts.enterUncategorizedAccountNames}
      value={value}
      {...props} />
  );
};

export default React.memo(SelectUncategorizedCategoryNames);
